export const headerStyle = () => {
    return {
        borderColor: '#a81933',
    };
};

export const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Group Name',
        sort: true,
        headerStyle: () => { return { width: '200px', ...headerStyle() }; },
    },
    {
        dataField: 'emailAddress',
        text: 'Group Email',
        sort: true,
        headerStyle: () => { return { width: '200px', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'description',
        text: 'Description',
        sort: true,
        headerStyle: () => { return { minWidth: '200px', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'communicationGroup',
        text: 'Communication Group',
        sort: true,
        headerStyle: () => { return { width: '200px', ...headerStyle() }; }
    },
    {
        dataField: 'usersCount',
        text: 'Users',
        sort: true,
        headerStyle: () => { return { width: '120px', ...headerStyle() }; }
    }
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];